









import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class HoverBox extends Vue {
  @Prop({ required: false }) readonly title?: string
}
